import { getMainEvent } from '@checkout-b/checkout/selectors/event';
import React from 'react';
import { useSelector } from 'react-redux';

const Header = ({ children }) => {
  return (
    <header className="branded-header">
      <div className="branded-header__content">
        {children}
      </div>
    </header>
  );
};

const DefaultHeaderLeft = ({ childrenBefore, childrenAfter }) => {
  const { styles } = useSelector((state) => state.ui.uiConfig);
  const { name, logo, logo_light } = useSelector((state) => state.partner);
  const event = useSelector(getMainEvent)?.event;

  // Prefer API-provided logo URLs if available
  const logoLight = logo_light || `${styles['GLOBAL__PARTNER__URL']}/assets/partners/${styles['GLOBAL__PARTNER__SLUG']}/images/logo-light.png`;
  const logoDark = logo || `${styles['GLOBAL__PARTNER__URL']}/assets/partners/${styles['GLOBAL__PARTNER__SLUG']}/images/logo-dark.png`;

  return (
    <div className="branded-header--left">
      {childrenBefore}
      {!event?.hide_nav_bar_logo && (
        <div className="branded-header__branding">
          <img className="branding--light" src={logoLight} alt={name} />
          <img className="branding--dark" src={logoDark} alt={name} />
        </div>
      )}
      {childrenAfter}
    </div>
  );
};

const HeaderRight = ({ children }) => <div className="branded-header--right">{children}</div>;

export const BrandedHeader = Object.assign(Header, {
  DefaultHeaderLeft,
  HeaderRight,
});
